export default __webpack_public_path__ + "static/media/list.7cedec9e.svg";